module.exports = __webpack_public_path__ + "img/accents-and-decor.6b8882b.jpg";